import ThreeStarIcon from './component.jsx'
export default ThreeStarIcon
